import moment from "moment"
import {
  SalesOrderStatuses,
  SyncPriceRulesQueryVariables,
  SyncSalesOrdersQueryVariables
} from "client/types"
import { UseSyncQueryPromise } from "../useSyncQuery"

const priceRulesLabel = "Price Rules"
const salesOrdersLabel = "Sales Orders"
export type ProductSyncFilter = {
  modifiedGt: string
}
export const convertSyncDateToFilter = (
  date: Date | undefined
): ProductSyncFilter | undefined =>
  date ? { modifiedGt: moment(date).format("YYYY-MM-DDTHH:mmZ") } : undefined

export const processSyncQuery = (propName: string) => (
  syncQuery: UseSyncQueryPromise
): Promise<{ sync: string; success: boolean }> =>
  syncQuery
    .then(({ count, batchCount }) => {
      console.log(`Synced ${count} ${propName} in ${batchCount} batches.`)

      return {
        sync: propName,
        success: true
      }
    })
    .catch(err => {
      console.error(`Sync error for ${propName}: `, err)

      return {
        sync: propName,
        success: false
      }
    })

export const syncCompanyData = (
  companies: ReadonlyArray<{ id: string } | null | undefined>,
  priceRules: (
    filter: NonNullable<SyncPriceRulesQueryVariables["filter"]>
  ) => UseSyncQueryPromise,
  salesOrders: (
    filter: NonNullable<SyncSalesOrdersQueryVariables["filter"]>
  ) => UseSyncQueryPromise
) => {
  const companyIds = Array.from(
    new Set(
      companies.flatMap(company =>
        typeof company?.id === "string" && company.id.length > 0
          ? [company.id]
          : []
      )
    )
  )
  if (companyIds.length === 0) {
    return [
      Promise.resolve({ sync: priceRulesLabel, success: true }),
      Promise.resolve({ sync: salesOrdersLabel, success: true })
    ]
  }
  return [
    processSyncQuery(priceRulesLabel)(priceRules({ companyIn: companyIds })),
    processSyncQuery(salesOrdersLabel)(
      salesOrders({
        status: SalesOrderStatuses.Unsigned,
        companies: companyIds
      })
    )
  ]
}
